<template lang="pug">
  div(:class="themeClass")
    footer.footer
      ul.footer-link
        template(v-if="isInternalTermOfServiceLink() && identifier() === 'mynavi'")
          li
            router-link(:to="{ name: 'MynaviTermsOfService' }") 利用規約
        template(v-else-if="isInternalTermOfServiceLink()")
          li
            router-link(:to="{ name: 'TermsOfService' }") 利用規約
        template(v-else)
          li
            a(:href="externalTermUrl()" target="_blank") 利用規約
        li
          a(:href="operatingCompanyUrl()" target="_blank") 運営会社
      p.copyright
        | &copy; {{ copyright() }}
</template>

<script>
  export default {
    computed: {
      themeClass () {
        if (location.hostname.includes('mynavi')) return 'theme-mynavi'
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/Footer.vue